export var development = {
    enviroment: "development",
    firebase: {
        apiKey: "AIzaSyB3ecatm8F2eADOdwG0EYEIs4RYJO_Bt-0",
        // authDomain: "blastdev-c73f0.firebaseapp.com",
        authDomain: "dev.wchsblast.com",
        databaseURL: "https://blastdev-c73f0.firebaseio.com",
        projectId: "blastdev-c73f0",
        storageBucket: "blastdev-c73f0.appspot.com",
        messagingSenderId: "122202127446",
        appId: "1:122202127446:web:d0f91affa67b1f2e"
    }
};

//# sourceMappingURL=development.js.map